import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { CarConfiMarketConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { CarConfiUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { ConfiguratorOption } from '~/app/pages/configurator/components/configurator-option';
import { ConflictsDialogWrapper } from '~/app/pages/configurator/components/conflict-dialog/conflict-dialog';
import { ConfiguratorPageStyle } from '~/app/pages/configurator/styles/configurator-page-style';
import { state } from '~/storage';
import { debounce } from '~/utils/debounce';

interface props {
	market: CarConfiMarketConfiguration | undefined;
	marketUi: CarConfiUiConfiguration | undefined;
}

export default function CarConfiPage({ market, marketUi }: props) {
	const setCombinations = useSetAtom(state.configuredCombinationsAtom);
	const setFilteredCombinations = useSetAtom(state.filteredCombinationsAtom);
	setCombinations(market?.combinations);

	const [isLandscape, setIsLandscape] = useAtom(state.isLandscape);
	const [conflict, setConflict] = useAtom(state.conflictAtom);

	useEffect(() => {
		// Check windows orientation to determine if to activate landscape mode
		const handleOrientationChange = debounce(() => {
			const isOrientationLandscape = window?.matchMedia('(orientation: landscape)').matches;
			setIsLandscape(isOrientationLandscape);
		}, 500);

		// Remove landscape mode when resizing window on desktop
		const handleResize = () => {
			if (window?.innerWidth > 1024) {
				setIsLandscape(false);
				document.body.style.position = '';
			}
		};

		window?.addEventListener('resize', handleResize);
		window?.addEventListener('orientationchange', handleOrientationChange);

		// Cleanup
		return () => {
			window?.removeEventListener('resize', handleResize);
			window?.removeEventListener('orientationchange', handleOrientationChange);
		};
	}, [isLandscape, setIsLandscape]);

	useEffect(() => {
		setFilteredCombinations(market?.combinations);
	}, []);

	if (!market || !marketUi) {
		return <></>;
	}

	return (
		<>
			<ConfiguratorPageStyle className={`${isLandscape && 'is-landscape'}`}>
				{conflict && conflict.conflict && (
					<ConflictsDialogWrapper
						data={conflict.conflict}
						open={!!conflict}
						onOpenChange={() => setConflict(null)}
					/>
				)}

				<div id="configurator-options-container" className="configurator__options">
					<ConfiguratorOption />
				</div>
			</ConfiguratorPageStyle>
		</>
	);
}
